import React, { useState } from "react";
import { MustLogIn, Home } from "./components";

const App: React.FC = () => {
  const [, setReload] = useState(0);
  const { k5u } = localStorage;

  const onLogout = (): void => {
    if (!window.confirm("You are about to be logged out")) return;

    localStorage.removeItem("k5u");
    setReload(Math.random());
  };

  if (!k5u) return <MustLogIn />;
  return <Home onLogout={onLogout} />;
};

export default App;
